import React, { Component, Fragment }  from 'react';
import { Rect, Image } from 'react-konva';
import {
  nodeWidth,
  nodeHeight,
  pedigreeNodeHeight,
  pedigreeIsTallNodeHeight,
  isDevelopment,
  cachetree,
  // debugWiderCatchForFetchProfiles,
} from '../../library/constants';
import {
  isMobileTablet, isMobilePhone, calcNodeColorObj, shadeColor
} from '../../library/calc';

export class ShadowNode extends Component {

  constructor(props){
    super(props);
    this.state = {
      highlight: false
    }
  }

  render () {

    let {
      left,
      top,
      isPedigree,
      pedigreeIsTall,
    } = this.props;

    const shortenForPedigree = ( pedigreeIsTall ? -9: -15);
    const adjustHeight = ( !isPedigree ? 0 : shortenForPedigree);

    left += 1.2;
    top += 1.2;

    return (
      <Rect
          x={left}
          y={top}
          visible={true}
          width={nodeWidth}
          height={nodeHeight + adjustHeight}
          strokeWidth={.5}
          stroke={'#808080'}
          fill={'#808080'}
          perfectDrawEnabled={false}
          listening={false}
        />
    );
  }
}

export class HighLightNode extends Component {

  constructor(props){
    super(props);
    this.state = {
      highlight: false
    }
  }

  addHighlight(bool, refNode){
    this.setState({
      highlight: bool
    })
  }

  render () {

    let {
      left,
      top,
      isPedigree,
      pedigreeIsTall,
    } = this.props;

    const expandBy = 9.7;
    const shortenForPedigree = ( pedigreeIsTall ? -9.5: -15);
    const adjustHeight = ( !isPedigree ? 0 : shortenForPedigree);

    left -= expandBy/2;
    top -= expandBy/2;

    return (
      <Rect
          x={left}
          y={top}
          visible={( this.state.highlight ? true: false)}
          width={nodeWidth + expandBy}
          height={nodeHeight + expandBy + adjustHeight}
          strokeWidth={.5}
          stroke={'#0040A0'}
          fill={'#6BADDE'}
          opacity={.2}
          perfectDrawEnabled={false}
          listening={false}
        />
    );
  }
}


export class Node extends Component {

  constructor(props){
    super(props);
    this.props.buildRefObj({key: `node_n-${this.props.n}`, objClass: this});
    this.state = {
      hovering: false,
    }
  }

  componentDidUpdate(){
    if(cachetree){
      this.refs.rectNodeCache.cache();
    }
  }

  testMethod(){
      console.log(`%cNode testMethod is executed for ${this.props.nodeObjs[this.props.node].fn} ${this.props.nodeObjs[this.props.node].ln} `, [
      'color: white',
      'background: black',
      'font-size: 19px',
      'border: 5px solid red',
      'padding: 10px',
      ].join(';'));
  }

  click(){
    const {
      a,
      n,
      nt,
      onClickedNode,
      openAddNodeForm,
      stopStageClickPropagation,
      showTreeOverlay,
      pedigreeGhostAddLabel,
      pedigreeParentNodeId,
      pedigreeGhostMale,
    } = this.props;

    if(this.isPedigreeGhostAddNodeDisabled()) return;
    stopStageClickPropagation({fromWhere:'click to openAddNodeForm'});
    if(isMobilePhone() ) return;
    if(typeof(pedigreeGhostAddLabel) !== 'undefined'){
      if(!isDevelopment){
        openAddNodeForm({
          node: pedigreeParentNodeId,
          pedigreeGhostAddLabel,
          relationShip: ( pedigreeGhostMale ? 'father': 'mother')
        });
      }
      else{
        alert('You are on development')
        // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
      }
      return;
    }
    if(typeof(a) === 'undefined' && nt === 'ghost') return;
    if(nt === 'ghost') showTreeOverlay();
    if(n > 0){
      onClickedNode(n);
    }
  }

  callHover(hovering){
    this.setState({hovering});
  }

/*
  nodeHasRestrictedViews(){
    return typeof(this.props.nodeObj.nvp) !== 'undefined';
  }
*/

  isWhitePedigreeNode(){
    return !this.props.pedigreeGhostAddLabel && this.props.n < 0
  }

  isPedigreeGhost(){
    return typeof(this.props.nodeObj.isPedigreeGhost) !== 'undefined' && this.props.n < 0
  }

  isPedigreeGhostAddNodeDisabled(){
      return typeof(this.props.nodeObjs) !== 'undefined' && typeof(this.props.nodeObj.pedigreeGhostAddLabel) !== 'undefined' &&
      typeof(this.props.nodeObjs[this.props.nodeObj.pedigreeParentNodeId].a) === 'undefined'
  }

  render () {

    let { g } = this.props;

    const {
      a,
      nodeObj,
      nodeObjs,
      n,
      nt,
      addNodeObj,
      left,
      top,
      focus,
      onClickedNode,
      openAddNodeForm,
      cursorBecomesMove,
      cursorBecomesPointer,
      userTouchedNode,
      stopStageClickPropagation,
      hideMatchBubble,
      // showTreeOverlay,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      nodeIsGhost,
      setFlipCardScreenIsOn,
      pedigreeGhostAddLabel,
      pedigreeParentNodeId,
      pedigreeGhostMale,
      pedigreeIsTall,
      storePrIdToLocationHistory,
      maleCustomColor,
      femaleCustomColor,
      unGenderedCustomColor,
      shadeLevel,
      // queueLocalStateUpdates,
      // releaseLocalStateUpdates
    } = this.props;

    // const useThisGender = (this.nodeHasRestrictedViews() ? undefined: g);

    const nodeColorObj = calcNodeColorObj({
        focus,
        g/*: useThisGender*/,
        nodeObj,
        nodeObjs,
        minimap: this.props.minimap,
        isHover: this.state.hovering,
        maleCustomColor,
        femaleCustomColor,
        unGenderedCustomColor,
        undefinedGenderColor: '#DADADA',
    });

    let pedigreeHeight = ( pedigreeIsTall ? pedigreeIsTallNodeHeight: pedigreeNodeHeight)
    let height = ( this.props.isPedigree ?  pedigreeHeight: nodeHeight);

    // const pedigreeGhostAddNodeDisabled = () => {
    //   return typeof(nodeObjs) !== 'undefined' && typeof(nodeObj.pedigreeGhostAddLabel) !== 'undefined' &&
    //   typeof(nodeObjs[nodeObj.pedigreeParentNodeId].a) === 'undefined'
    // }

    // const nodeRef = React.createRef();

    let fillLinearGradientStartPoint = { x : nodeWidth/2, y : nodeColorObj.yStartPointGradient};
    let fillLinearGradientEndPoint = { x : nodeWidth/2, y : nodeColorObj.yEndPointGradient};
    let fillLinearGradientColorStops = nodeColorObj.fillLinearGradientColorStops;

    if(typeof(focus) !== 'undefined' && focus === 1 && this.state.hovering){
      fillLinearGradientColorStops = [  0,  "#FDFDFD",  1,  "#FDFDFD" ]
    }

    // document.getElementById("debugDiv4").innerHTML = `${fillLinearGradientStartPoint.x}:${fillLinearGradientStartPoint.y}`;
    // document.getElementById("debugDiv3").innerHTML = `${fillLinearGradientEndPoint.x}:${fillLinearGradientEndPoint.y}`;
    // document.getElementById("debugDiv2").innerHTML = `${fillLinearGradientColorStops}:`;
    // document.getElementById("debugDiv1").innerHTML = `${nodeColorObj.strokeColor}`;


    return (
      <Fragment>
        <Rect
            x={left}
            y={top}
            shadowColor={'grey'}
            shadowBlur={0}
            width={nodeWidth}
            height={height}
            strokeWidth={.5}
            stroke={shadeColor(nodeColorObj.strokeColor, shadeLevel)}
          />
        <Rect
            ref={'rectNodeCache'}
            x={left}
            y={top}
            shadowColor={'grey'}
            shadowBlur={0}
            width={nodeWidth}
            height={height}
            // strokeWidth={.5}
            // stroke={shadeColor(nodeColorObj.strokeColor, shadeLevel)}
            // stroke={'red'}
            // stroke="red"
            // fill="green"
            fillLinearGradientStartPoint={fillLinearGradientStartPoint}
            fillLinearGradientEndPoint={fillLinearGradientEndPoint}
            fillLinearGradientColorStops={fillLinearGradientColorStops}

            onTouchStart={()=>{

              if(typeof(a) === 'undefined' && nt === 'ghost') return;
              if(this.isPedigreeGhostAddNodeDisabled()) return;

              stopStageClickPropagation({fromWhere:'node component '});
              userTouchedNode({
                node: n,
                callback: ()=>{

                  if(isMobilePhone() ) {

                    let screenIsOn = `mainFromHome`;
                    if(nodeIsGhost({nodeObj, n}) || this.isPedigreeGhost()) {
                      screenIsOn = `addFormFromGhost`;
                    } else {
                      storePrIdToLocationHistory({userExitsFlipCard: false, prId: nodeObj.prId})
                    }

                    if(this.isPedigreeGhost() || n > 0){

                      /*

                        console.log('start update queue state');
                        queueLocalStateUpdates({
                          flipCardScreenIsOn: screenIsOn,
                          nodeForFlipFocus: n,
                        })
                        releaseLocalStateUpdates();

                       */

                      setFlipCardScreenIsOn({screenIsOn});
                      setNodeForFlipFocus(n);
                      setShowMobileFlipCard(n);
                    }

                    if(nodeIsGhost({nodeObj, n}) || this.isPedigreeGhost()) {

                      if(!isDevelopment){

                        let marriageId = undefined;
                        let choice = undefined;
                        let pr_id = undefined;
                        setTimeout(() => {
                          if(typeof(pedigreeGhostAddLabel) !== 'undefined'){
                            choice = ( pedigreeGhostMale ? 'father' : 'mother');
                            pr_id = nodeObjs[nodeObj.pedigreeParentNodeId].prId;
                            window.openAddNode(pr_id, choice, marriageId);
                          } else {
                            marriageId = addNodeObj.marriageId;
                            choice = addNodeObj.choice;
                            pr_id = addNodeObj.pr_id;
                            window.openAddNode(pr_id, choice, marriageId);
                          }

                        }, 700);
                      }
                      else{
                        // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
                      }
                    }
                  }

                  if(isMobileTablet() ) {

                    if(typeof(pedigreeGhostAddLabel) !== 'undefined'){
                      if(!isDevelopment){
                        openAddNodeForm({
                          node: pedigreeParentNodeId,
                          relationShip: ( pedigreeGhostMale ? 'father': 'mother')
                        });
                      }
                      else{
                        console.log(n);
                        alert('You are on development')
                        // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
                      }
                      return;
                    }
                    if( parseInt(n, 10) > 0) onClickedNode(n);

                  }

                },
                fromWhere: 'node'});
            }}

            onMouseover={()=>{
              hideMatchBubble();
            }}

            onClick={this.click.bind(this)}

            onMouseenter={()=>{
              if(!this.isWhitePedigreeNode() && !this.isPedigreeGhostAddNodeDisabled()){
                this.callHover(true);
                cursorBecomesPointer();
              }
            }}

            onMouseleave={()=>{
              this.callHover(false);
              cursorBecomesMove();
            }}


        onMousedown={()=>{   // bookmarkPleaseRemove Node

             console.log(`%c onMouseDown2`, [
               'color: white',
               'background: green',
               'font-size: 14px',
               'border: 5px solid red',
               'padding: 10px',
               ].join(';'));

        }}
        onMouseup={()=>{

             console.log(`%c onMouseUp2`, [
               'color: white',
               'background: orange',
               'font-size: 14px',
               'border: 5px solid red',
               'padding: 10px',
               ].join(';'));

        }}

            // onDragOver={(e)=>{
            //   e.preventDefault();
            //   console.log('onDragOver');
            // }}

            // onDrop={(e)=>{
            //   e.preventDefault();
            //   console.log('onDrop');
            // }}

          />
      </Fragment>
    );
  }
}


export class NodeSvg extends React.Component {

    nodeHasRestrictedViews(){
      return typeof(this.props.nodeObj.nvp) !== 'undefined';
    }

    isWhitePedigreeNode(){
      return !this.props.pedigreeGhostAddLabel && this.props.n < 0
    }

    isPedigreeGhost(){
      return typeof(this.props.nodeObj.isPedigreeGhost) !== 'undefined' && this.props.n < 0
    }

    render() {

    // let { g } = this.props;

    const {
      a,
      nodeObj,
      nodeObjs,
      n,
      nt,
      addNodeObj,
      left,
      top,
      // focus,
      onClickedNode,
      openAddNodeForm,
      cursorBecomesMove,
      cursorBecomesPointer,
      userTouchedNode,
      stopStageClickPropagation,
      hideMatchBubble,
      showTreeOverlay,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      nodeIsGhost,
      setFlipCardScreenIsOn,
      pedigreeGhostAddLabel,
      pedigreeParentNodeId,
      pedigreeGhostMale,
      pedigreeIsTall,
      storePrIdToLocationHistory,
      nodeSvgImg,
    } = this.props;

    // const useThisGender = (this.nodeHasRestrictedViews() ? undefined: g);
    // const nodeColorObj = calcNodeColorObj({focus, g: useThisGender, nodeObj, nodeObjs});

    let pedigreeHeight = ( pedigreeIsTall ? pedigreeIsTallNodeHeight: pedigreeNodeHeight)
    let height = ( this.props.isPedigree ?  pedigreeHeight: nodeHeight);

    const pedigreeGhostAddNodeDisabled = () => {
      return typeof(nodeObjs) !== 'undefined' && typeof(nodeObj.pedigreeGhostAddLabel) !== 'undefined' &&
      typeof(nodeObjs[nodeObj.pedigreeParentNodeId].a) === 'undefined'
    }

      return (
          <Image
            image={nodeSvgImg}
            width={nodeWidth}
            height={height}
            x={left}
            y={top}


            onTouchStart={()=>{

              if(typeof(a) === 'undefined' && nt === 'ghost') return;
              if(pedigreeGhostAddNodeDisabled()) return;

              stopStageClickPropagation({fromWhere:'node component '});
              userTouchedNode({
                node: n,
                callback: ()=>{

                  if(isMobilePhone() ) {

                    let screenIsOn = `mainFromHome`;
                    if(nodeIsGhost({nodeObj, n}) || this.isPedigreeGhost()) {
                      screenIsOn = `addFormFromGhost`;
                    } else {
                      storePrIdToLocationHistory({userExitsFlipCard: false, prId: nodeObj.prId})
                    }

                    if(this.isPedigreeGhost() || n > 0){
                      setFlipCardScreenIsOn({screenIsOn});
                      setNodeForFlipFocus(n);
                      setShowMobileFlipCard(n);
                    }

                    if(nodeIsGhost({nodeObj, n}) || this.isPedigreeGhost()) {

                      if(!isDevelopment){

                        let marriageId = undefined;
                        let choice = undefined;
                        let pr_id = undefined;
                        setTimeout(() => {
                          if(typeof(pedigreeGhostAddLabel) !== 'undefined'){
                            choice = ( pedigreeGhostMale ? 'father' : 'mother');
                            pr_id = nodeObjs[nodeObj.pedigreeParentNodeId].prId;
                            window.openAddNode(pr_id, choice, marriageId);
                          } else {
                            marriageId = addNodeObj.marriageId;
                            choice = addNodeObj.choice;
                            pr_id = addNodeObj.pr_id;
                            window.openAddNode(pr_id, choice, marriageId);
                          }

                        }, 700);
                      }
                      else{
                        // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
                      }
                    }
                  }

                  if(isMobileTablet() ) {

                    if(typeof(pedigreeGhostAddLabel) !== 'undefined'){
                      if(!isDevelopment){
                        openAddNodeForm({
                          node: pedigreeParentNodeId,
                          relationShip: ( pedigreeGhostMale ? 'father': 'mother')
                        });
                      }
                      else{
                        console.log(n);
                        alert('You are on development')
                        // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
                      }
                      return;
                    }
                    if( parseInt(n, 10) > 0) onClickedNode(n);

                  }

                },
                fromWhere: 'node'});
            }}

            onMouseover={()=>{
              hideMatchBubble();
            }}

            onClick={()=>{
              if(pedigreeGhostAddNodeDisabled()) return;
              stopStageClickPropagation({fromWhere:'click to openAddNodeForm'});
              if(isMobilePhone() ) return;
              if(typeof(pedigreeGhostAddLabel) !== 'undefined'){
                if(!isDevelopment){
                  openAddNodeForm({
                    node: pedigreeParentNodeId,
                    pedigreeGhostAddLabel,
                    relationShip: ( pedigreeGhostMale ? 'father': 'mother')
                  });
                }
                else{
                  alert('You are on development')
                  // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
                }
                return;
              }
              if(typeof(a) === 'undefined' && nt === 'ghost') return;
              if(nt === 'ghost') showTreeOverlay();
              if(n > 0) onClickedNode(n);
            }}


            onMouseenter={()=>{
              if(!this.isWhitePedigreeNode() && !pedigreeGhostAddNodeDisabled()) cursorBecomesPointer();
            }}

            onMouseleave={()=>{
              cursorBecomesMove();
            }}

        onMousedown={()=>{  // bookmarkPleaseRemove NodeSvg

             console.log(`%c onMouseDown 1`, [
               'color: white',
               'background: green',
               'font-size: 14px',
               'border: 5px solid red',
               'padding: 10px',
               ].join(';'));

        }}

        onMouseup={()=>{

             console.log(`%c onMouseUp 1`, [
               'color: white',
               'background: orange',
               'font-size: 14px',
               'border: 5px solid red',
               'padding: 10px',
               ].join(';'));

        }}

          />
      );
    }
}

